import { ChatAreaProps } from 'interfaces/components/chatbot/ChatArea';
import ChatMessage from './ChatMessage';
import MarkdownRender from './MarkdownRender';

const ChatArea = ({
  messages,
  onSuggestedQuestionClick,
  chatAreaRef,
  chatbotData,
  bubbleMaxWidth
}: ChatAreaProps) => {
  const hasLoadingMessage = messages.some(message => message.isLoading);
  const showIntro =
    messages.length === 0 && !hasLoadingMessage && chatbotData !== null;

  return (
    <div
      ref={chatAreaRef}
      className={`flex-1 bg-gray-200 dark:bg-gray-800 rounded-lg p-4 flex flex-col ${
        messages.length > 0 && !hasLoadingMessage ? '' : 'justify-self-auto'
      } gap-2 overflow-y-scroll`}
    >
      {showIntro && (
        <>
          <div
            className={`bg-white w-fit dark:bg-gray-700 rounded-e-2xl rounded-ss-2xl rounded-es-lg px-3 py-2 border border-gray-400 dark:border-gray-600 break-words whitespace-pre-wrap`}
            style={{
              maxWidth: `${bubbleMaxWidth}px`,
              overflowWrap: 'anywhere'
            }}
          >
            <MarkdownRender className='text-sm'>
              {chatbotData?.data.Welcome_Message || ''}
            </MarkdownRender>
          </div>

          {chatbotData?.data.QUESTIONS.map((question, index) => (
            <button
              key={index}
              onClick={() => onSuggestedQuestionClick(question)}
              className={`w-fit text-sm bg-white text-green-700 dark:bg-gray-700 dark:text-green-200 rounded-e-2xl rounded-ss-2xl rounded-es-2xl px-3 py-2 hover:bg-green-200 dark:hover:bg-gray-700 border border-solid border-green-300 transition-colors cursor-pointer break-words whitespace-pre-wrap`}
              style={{
                maxWidth: `${bubbleMaxWidth}px`,
                overflowWrap: 'anywhere'
              }}
            >
              {question}
            </button>
          ))}
        </>
      )}

      {messages.map(message => (
        <div key={message.id}>
          <ChatMessage message={message} bubbleMaxWidth={bubbleMaxWidth} />
        </div>
      ))}
    </div>
  );
};

export default ChatArea;
